import React, { useState, useEffect } from 'react';
import { AppProvider } from '@shopify/polaris';
import en from '@shopify/polaris/locales/en.json';
import '@shopify/polaris/build/esm/styles.css';
import LoginBanner from '../assets/img/Login_Banner.png';
import { useNavigate } from 'react-router-dom';

import {
  Page,
  Card,
  TextField,
  Button,
  Text,
  BlockStack,
  Layout,
} from '@shopify/polaris';

export default function LoginPage() {
  const baseUrl = process.env.REACT_APP_API_URL;
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [emailError, setEmailError] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [messerror, setMessError] = useState('');
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token) {
      navigate('/dashboard', { replace: true });
    }
  }, [navigate]);

  const validateEmail = (value) => {
    const isValid = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
    return isValid ? '' : 'Enter a valid email address';
  };

  const handleSubmit = () => {
    const emailValidation = validateEmail(email);
    const passwordValidation = password ? '' : 'Password is required';

    setEmailError(emailValidation);
    setPasswordError(passwordValidation);

    if (!emailValidation && !passwordValidation) {
      const loginData = { email, password };

      fetch(`${baseUrl}/api/auth/login`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(loginData),
      })
        .then(async (response) => {
          const data = await response.json();
          if (!response.ok) {
            throw new Error(data.message || "Login failed!");
          }

          setMessError('');
          localStorage.setItem("token", data.token);
          navigate('/dashboard', { replace: true });
        })
        .catch((error) => {
          setMessError(error.message);
        });
    }
  };

  return (
    <div className='login_page' style={{ backgroundImage: `url(${LoginBanner})` }}>
      <AppProvider i18n={en}>
        <Page narrowWidth>
          <Layout>
            <Layout.Section>
              <Card>
                <form
                  onSubmit={(e) => {
                    e.preventDefault();
                    handleSubmit();
                  }}
                >
                  <BlockStack gap="300">
                    <div className='login_title'>
                      <Text variant="headingLg" as="h2">
                        Login
                      </Text>
                      <Text variant="bodyMd" tone="subdued">
                        Enter your credentials to continue
                      </Text>
                    </div>

                    <TextField
                      placeholder="Email Address"
                      value={email}
                      onChange={(val) => {
                        setEmail(val);
                        setEmailError('');
                      }}
                      error={emailError}
                      autoComplete="off"
                    />

                    <TextField
                      type="password"
                      placeholder="Password"
                      value={password}
                      onChange={(val) => {
                        setPassword(val);
                        setPasswordError('');
                      }}
                      error={passwordError}
                      autoComplete="current-password"
                    />

                    <div className='btn_login'>
                      <Button submit primary>
                        Sign In
                      </Button>
                    </div>

                    {messerror && (
                      <p className='mess_error'>{messerror}</p>
                    )}
                  </BlockStack>
                </form>
              </Card>
            </Layout.Section>
          </Layout>
        </Page>
      </AppProvider>
    </div>
  );
}